import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '@frameworks/redux';

import { CollectionState, DeevyNft } from '@types';

export const collectionInitialState: CollectionState = {
  current: [],
  isLoading: false,
  error: undefined,
};

const getCollection = createAsyncThunk<
  { collection: DeevyNft[] },
  void,
  ThunkAPI
>('collection/getCollection', async (_, { getState, extra }) => {
  const { services } = extra;
  const { deevyService } = services;
  const { wallet } = getState();

  if (!wallet.selectedAddress) throw new Error('Wallet not connected');

  const collection = await deevyService.getCollection({
    walletAddress: wallet.selectedAddress,
  });

  return { collection };
});

const collectionSlice = createSlice({
  name: 'collection',
  initialState: collectionInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCollection.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(getCollection.fulfilled, (state, { payload }) => {
        state.current = payload.collection;
        state.isLoading = false;
      })
      .addCase(getCollection.rejected, (state, { error }) => {
        state.current = [];
        state.isLoading = false;
        state.error = error.message;
      });
  },
});

export const CollectionActions = {
  ...collectionSlice.actions,
  getCollection,
};
export default collectionSlice.reducer;
